/* BYOB kit helpers for the theme cart (slide-out drawer + cart page).
   - Removing any kit scent removes the whole kit: all scents and its add-ons.
   - window.BYOBCart lets the BYOB page refresh and open the drawer after adding. */
(() => {
  if (window.BYOBCart) return;
  const SECTION = 'minicart-form';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartEl = () => document.querySelector('cart-notification');
  const post = (url, body) =>
    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

  // Mirrors what the theme's cart-notification does after a quantity change.
  async function refresh(sections) {
    const cart = await fetch(root + 'cart.js').then((r) => r.json());
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.innerHTML = el.classList.contains('cart-count-drawer')
        ? `(${cart.item_count})`
        : cart.item_count > 100 ? '~' : cart.item_count;
    });
    const total = document.querySelector('header-total-price');
    if (total && total.updateTotal) total.updateTotal(cart);
    const target = document.getElementById(SECTION);
    const html = sections && sections[SECTION];
    if (target && html) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#' + SECTION);
      if (fresh) target.innerHTML = fresh.innerHTML;
    }
    const ship = document.querySelector('free-ship-progress-bar');
    if (ship && ship.init) ship.init(cart.items_subtotal_price);
    const el = cartEl();
    if (el && el.cartAction) el.cartAction();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'byob', cartData: cart });
    }
    return cart;
  }

  function canOpen() {
    const el = cartEl();
    const box = el && el.querySelector('.header__minicart');
    return !!(el && el.open && document.getElementById(SECTION) && box && !box.classList.contains('go_to_cart_page'));
  }

  function open() {
    const el = cartEl();
    if (el && el.open) el.open();
  }

  async function removeKit(code, btn) {
    const cart = await fetch(root + 'cart.js').then((r) => r.json());
    const updates = {};
    cart.items.forEach((item) => {
      if (item.properties && item.properties._byob_kit === code) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    const onCartPage = !!btn.closest('#main-cart-items, .page__cart-item');
    const data = await post('cart/update.js', onCartPage ? { updates } : { updates, sections: SECTION });
    if (onCartPage) {
      window.location.reload();
      return;
    }
    await refresh(data.sections);
  }

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('[data-byob-kit-remove]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      const box = document.querySelector('.header__minicart');
      if (box) box.classList.add('start', 'loading');
      removeKit(btn.dataset.byobKitRemove, btn)
        .catch(() => window.location.reload())
        .finally(() => {
          btn.classList.remove('is-busy');
          if (box) box.classList.remove('start', 'loading');
        });
    },
    true
  );

  window.BYOBCart = { sections: SECTION, refresh, open, canOpen };
})();
